<template>
  <v-app>
    <login-dialog ref="loginDialog" />

    <v-app-bar
      app
      color="primary"
      dark
    >

      <v-btn text to="/">
        <v-icon class="mr-2">mdi-domain</v-icon>
        <span>Zábory</span>
      </v-btn>

      <v-btn text to="/map">
        <v-icon class="mr-2">mdi-map</v-icon>
        <span>Mapa</span>
      </v-btn>

      <v-btn
          v-if="isAdmin"
          to="users"
          text
      >
        <v-icon class="mr-2">mdi-account</v-icon>
        <span>Uživatelé</span>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        @click="logOut"
        text
      >
        <span class="mr-2">{{ getUsername }}</span>
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import LoginDialog from '@/components/LoginDialog';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: { LoginDialog },

  computed: {
    ...mapGetters(["isAdmin", "getUsername"])
  },

  methods: {
    logOut() {
      this.$refs.loginDialog.logOut();
    }
  }
};
</script>
